import { ONE_YEAR_SECONDS, getCookie, setCookie } from '@growtherapy/analytics';
import { GROW_LANG_COOKIE_TOKEN_NAME, LOCALE_DEFAULT } from '@growtherapy/i18n';

export function getStoredLanguagePreference(): string {
  const value = getCookie(GROW_LANG_COOKIE_TOKEN_NAME);
  if (typeof value === 'string' && value.length > 0) {
    return value;
  }
  return LOCALE_DEFAULT;
}

export function hasStoredLanguagePreference(): boolean {
  const value = getCookie(GROW_LANG_COOKIE_TOKEN_NAME);
  return !!value;
}

export function setStoredLanguagePreference(locale: string): void {
  setCookie(GROW_LANG_COOKIE_TOKEN_NAME, locale, ONE_YEAR_SECONDS);
}

export function getPreferredSupportedLocale(supportedLocales: string[]): string | null {
  const browserLang = window.navigator.language;
  const baseBrowserLang = browserLang.split('-')[0].toLowerCase();
  const matchedLocale = supportedLocales.find((loc) => loc.toLowerCase() === baseBrowserLang);
  return matchedLocale ?? null;
}
